import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "./app/index.css";
import App from "./app/App";
import { configureAmplify } from "./app/bootstrap/configureAmplify";
import { runStartupEffects } from "./app/bootstrap/runStartupEffects";

runStartupEffects();
configureAmplify();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
